/**
 * Surcharge Types Constants
 */
export const SURCHARGE_TYPES = [
    { value: "blackouts", label: "Blackouts Dates" },
    { value: "special_event", label: "Special Event" },
    { value: "weekend_dates", label: "Weekend Fees" },
    { value: "night_fees", label: "Night Fees" },
    { value: "seasonal", label: "Seasonal Fees" },
    { value: "availability_on_request", label: "Availability on Request" },
]